import { render, staticRenderFns } from "./AddToCartButton.vue?vue&type=template&id=f5b0b7ea&scoped=true&"
import script from "./AddToCartButton.vue?vue&type=script&lang=js&"
export * from "./AddToCartButton.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartButton.vue?vue&type=style&index=0&id=f5b0b7ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b0b7ea",
  null
  
)

export default component.exports